import { MultiSelect } from "./multiSelect.js";
import { Button } from "./button.js";
import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { SheetAfterInteractionEventType, SheetEventType } from "../../../siteManagement/sheet.js";
import { Config } from "../config/config.js";
import { TextBox, TextBoxProps } from "./textBox.js";
import { ComponentHelper } from "../util/componentHelper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { CommandManagerAPI, StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";
export class IsSearchField extends React.Component<IsSearchFieldProps, any>{
    private _autoComplete: kendo.ui.AutoComplete;
    private _autoCompleteRef: HTMLInputElement = null;
    private _multiSelect: MultiSelect;
    private _multiSelectRef: MultiSelect = null;
    private _multiSelectDataSource = [];
    private _multiSelectValue = [];
    private _multiSelectRawDataSource = [];
    private _hasValue = Helper.hasValue;
    private _value: any;
    private _enabled = false;
    private _textBoxProps: TextBoxProps = null;
    private _autoCompleteUrl: string = "";
    private _autoCompleteHasTemplate: boolean = false;
    private _textBoxRef: TextBox = null;

    constructor(props: IsSearchFieldProps) {
        super(props)
        if (props.multiSelectMode) {
            //this._multiSelectValue = this.props.value;
            this._setMultiSelectData(props.value, props.field.dataTextField, props.field.dataValueField);
        } else {
            if (!this.props.field.autocompleteEnabled) {
                this._textBoxProps = ComponentHelper.createFactory().getDefaultTextBoxProps();
                this._textBoxProps.field.model = props.field.model;
                this._textBoxProps.field.name = props.field.name;
                this._textBoxProps.onChange = (field, value) => {
                    this.props.onChange(props.field, value);
                };
                this._textBoxProps.required = props.required
            }
        }
        this._autoCompleteHasTemplate = this._dataSourceUrlHasTemplate(props.field.autocompleteUrl);
        if (this._autoCompleteHasTemplate) {
            this._autoCompleteUrl = Config.baseUrl + this._processTemplate(this.props.field.autocompleteUrl);
        } else {
            this._autoCompleteUrl = Config.baseUrl + this.props.field.autocompleteUrl;
        }
        this._setAutoCompleteUrl(false);
    }

    private _setMultiSelectData = (items: Array<any>, textField: string, valueField: string) => {
        let ds = [];
        //create a new data source
        if (Array.isArray(items)) {
            for (var i = 0; i < items.length; i++) {
                let tmp = {};
                tmp[this.props.field.dataTextField] = items[i][textField];
                tmp[this.props.field.dataValueField] = items[i][valueField];
                ds.push(tmp);
            }
        }
        this._multiSelectRawDataSource = items;
        this._multiSelectDataSource = ds;
        //copy the data source into the value (not in "props", because you "can't change props"...)
        this._multiSelectValue = ds.slice();
        if (this._hasValue(this._multiSelect)) {
            this._multiSelect.setDataSourceItems(ds);
            this.setState({});
        }
    }


    private _openAddNew = () => {
        if (!this._hasValue(this.props.field.canOpenAdd) || (typeof this.props.field.canOpenAdd === "boolean" && this.props.field.canOpenAdd) || this.props.handleEval(this.props.field.canOpenAdd as string)) {
            let url = Config.baseUrl + this.props.field.addNewUrl;
            if (this._hasValue(this.props.field.addNewUrlParameters)) {
                if (url.indexOf("?") === -1) {
                    url += "?";
                }
                const params = [];
                for (let p in this.props.field.addNewUrlParameters) {
                    const val = this.props.handleEval(this.props.field.addNewUrlParameters[p]);
                    if (this._hasValue(val)) {
                        params.push(`${p}=${encodeURIComponent(val)}`);
                    }
                }
                if (params.length > 0) {
                    if (url.lastIndexOf("?") !== url.length) {
                        //at least another parameter present
                        url += "&";
                    }
                    url += params.join("&");
                }
            }

            const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true, preventUrlChangeOnNew: true });
            sheet.setTitle(this.props.field.newObjectWindowTitle);
            sheet.bind(SheetEventType.SavedSuccessfully, (ev) => {
                this.props.onChange(this.props.field, ev.entity[this.props.field.newObjectKey], ev.entity);
            });
        }
    }

    private _getButtonStyle = (isDisabled: boolean, roundBorder: boolean = false) => {
        const buttonStyle: React.CSSProperties = {
            display: this.props.disabled || isDisabled ? "none" : "inline-flex",
            height: "38px",
            width: "28px",
            borderColor: "#ced4da",
            borderLeft: "none",
            backgroundColor: "#e4e7eb"
            //marginLeft: "5px"
        };

        return buttonStyle;
    }

    private _deleteValue = () => {
        this.props.onChange(this.props.field, null, null);
    }

    private _execCustomFunction = () => {
        this.props.handleEval(this.props.field.customButtonFunction);
    }

    componentWillUnmount() {
        if (this._hasValue(this._autoComplete)) {
            this._autoComplete.destroy();
        }
    }

    onAdditionalData = (e) => {
        var jsonParameter = {};
        jsonParameter["text"] = e.filter.filters.length > 0 ? e.filter.filters[0].value : "";
        if (this.props.field.autocompleteAdditionalFilterParameter && this.props.field.autocompleteAdditionalFilterParameterName)
            jsonParameter[this.props.field.autocompleteAdditionalFilterParameterName] = this.props.handleEval(this.props.field.autocompleteAdditionalFilterParameter);
        return jsonParameter;
    }

    componentDidMount() {
        var datasource = null;

        this._enabled = this.isEnabled();
        this._value = this.props.value;

        if (!this.props.multiSelectMode || (this.props.field.autocompleteEnabled && this.props.field.autoCompleteMultiMode)) {
            if (this.props.field.autocompleteEnabled) {
                datasource = new kendo.data.DataSource({
                    transport: {
                        read: {
                            url: this._autoCompleteUrl,
                            data: this.onAdditionalData
                        }
                    },
                    serverFiltering: true
                });

                this._autoComplete = $(this._autoCompleteRef).kendoAutoComplete({
                    //enable: this._enabled,
                    height: 500,
                    dataSource: datasource,
                    dataTextField: this.props.field.autocompleteDataTextField,
                    template: this.props.field.autocompleteTemplate,
                    clearButton: this.props.field.clearButtonEnabled ?? true,
                    change: (ev) => {
                        this._value = ev.sender.value();
                        if (Helper.isNullOrEmpty(this._value)) {
                            this.props.onChange(this.props.field, ev.sender.value(), null);
                        } else {
                            let dataItem = ev.sender.dataItem(0);

                            let i = 0;
                            for (i = 0; i < ev.sender.ul.children().length; i++) {
                                if (!Helper.hasValue(ev.sender.dataItem(i)))
                                    continue;

                                if (((this.props.field.autocompleteDataTextField !== "") && (ev.sender.dataItem(i)[this.props.field.autocompleteDataTextField] === this._value))
                                    || ((this.props.field.autocompleteDataTextField === "") && (ev.sender.dataItem(i) === this._value))) {
                                    dataItem = ev.sender.dataItem(i);
                                    break;
                                }
                            }
                            this.props.onChange(this.props.field, ev.sender.value(), dataItem);
                        }
                    },
                    select: () => {
                    }

                }).data("kendoAutoComplete");
                this._autoComplete.value(this._value);
                if (!this._enabled) {
                    this._autoComplete.readonly(true);
                }
                if (this.props.field.focus)
                    this._autoComplete.focus();

                if (this.props.field.listWidth !== null && window.matchMedia(`(min-width: ${this.props.field.listWidth}px)`).matches)
                    this._autoComplete.list.width(this.props.field.listWidth);
            }
        }
    }

    private _setAutoCompleteUrl = (callSetState: boolean) => {
        if (this._autoCompleteHasTemplate && Helper.hasValue(this._autoComplete) && this.props.field.autocompleteEnabled) {
            let oldAutoCompleteUrl = this._autoCompleteUrl;
            this._autoCompleteUrl = Config.baseUrl + this._processTemplate(this.props.field.autocompleteUrl);
            if (oldAutoCompleteUrl !== this._autoCompleteUrl) {
                this._autoComplete.setDataSource(new kendo.data.DataSource({
                    transport: {
                        read: {
                            url: this._autoCompleteUrl,
                            data: this.onAdditionalData
                        }
                    },
                    serverFiltering: true
                }));
                this._autoComplete.value(this.props.value);
                if (callSetState)
                    this.setState({}, () => this._autoComplete.refresh());
            }
        }
    }

    isEnabled() {
        var field = this.props.field;
        return !this.props.disabled && (this._hasValue(field.readOnlyTextField) ? ((typeof (field.readOnlyTextField) === "string" && !this.props.handleEval(field.readOnlyTextField as string)) || !field.readOnlyTextField) : true);
    }




    isCheckReadOnly(field_val) {
        if (this._hasValue(field_val))
            return (typeof (field_val) === "string") ? this.props.handleEval(field_val as string) : field_val;
        else
            return false;
    }



    componentDidUpdate(prevProps: IsSearchFieldProps, prevState) {
        let isEnabled = this.isEnabled();
        let triggerEnable = false;
        if (this._enabled !== isEnabled) {
            this._enabled = isEnabled;
            triggerEnable = true;
        }
        if (!this.props.multiSelectMode) {
            this._setAutoCompleteUrl(true);
            if (triggerEnable) {
                //this._autoComplete.enable(this._enabled);
                if (this._hasValue(this._autoComplete)) {
                    this._autoComplete.readonly(!this._enabled);
                }
            }
            if (this._value !== this.props.value) {
                this._value = this.props.value;
                if (this._hasValue(this._autoComplete)) {
                    this._autoComplete.value(this._value);
                }
            }
        }
        else {
            if (this.props.value != prevProps.value) {
                this._setMultiSelectData(this.props.value, this.props.field.dataTextField, this.props.field.dataValueField);
            }

            if (triggerEnable) {
                this._multiSelect.setEnabled(this._enabled);
            }
        }
    }

    _handleMultiSelectChange = (field, value, dataItems) => {
        this.props.onChange(field, value, dataItems);
        this._multiSelectValue = value;
    }

    openSearch = () => {
        var that = this;

        var dynamicSearchUrl = Config.baseUrl + this._processTemplate(this.props.field.searchWindowUrl);//this.props.field.searchWindowUrl;
        var field = this.props.field;

        // Parameter einsetzen falls definiert (eval über root component durchführen lassen)
        if (this._hasValue(field.searchWindowUrlParameterName) && this._hasValue(field.searchWindowUrlParameterModel)) {
            let parameterQualifier = dynamicSearchUrl.indexOf("?") != -1 ? "&" : "?";
            let paramValue = this.props.handleEval(field.searchWindowUrlParameterModel);
            if (this._hasValue(paramValue)) {
                dynamicSearchUrl = dynamicSearchUrl + parameterQualifier + field.searchWindowUrlParameterName + "=" + paramValue;
            }
        }
        if (this._hasValue(field.searchWindowUrlAdditionalParameterName) && this._hasValue(field.searchWindowUrlAdditionalParameterModel)) {
            let parameterQualifier = dynamicSearchUrl.indexOf("?") != -1 ? "&" : "?";
            let paramValue = this.props.handleEval(field.searchWindowUrlAdditionalParameterModel);
            if (this._hasValue(paramValue)) {
                dynamicSearchUrl = dynamicSearchUrl + parameterQualifier + field.searchWindowUrlAdditionalParameterName + "=" + paramValue;
            }
        }

        //wnd.refresh(dynamicSearchUrl);
        const sheet = General.Sheet.Manager.createSheetWithUrl(dynamicSearchUrl, null, { disableTabTitle: true });
        sheet.bind(SheetEventType.RowClicked, (data) => {
            if (typeof data === "object") {
                if (Helper.hasValue(this.props.field.fullObjectKey)) {
                    this.props.onChange(this.props.field, data[this.props.field.fullObjectKey], data);
                }
                this.props.handleIsSearchFieldFullObjectModel(this.props.field, data);
            }
            else {
                this.props.onChange(this.props.field, data, null);

            }
        });

        sheet.bind(SheetEventType.ItemsSelected, (data) => {
            if (this.props.multiSelectMode || (this.props.field.autocompleteEnabled && this.props.field.autoCompleteMultiMode)) {
                this._setMultiSelectData(data.data, this.props.field.searchTextField, this.props.field.searchValueField);
                //since the value is local and not a property of the model (entity), trigger a change with the right values
                this.props.onChange(this.props.field, this._multiSelectValue, data.data);

                //prevent double triggering...
                sheet.unbind(SheetEventType.ItemsSelected);
            }
        });
        if (this.props.multiSelectMode || (this.props.field.autocompleteEnabled && this.props.field.autoCompleteMultiMode)) {
            sheet.bind(SheetEventType.SetSelectedItems, function (callback) {
                if (that._hasValue(callback)) {
                    let rawDS = [];
                    for (var i = 0; i < that._multiSelectValue.length; i++) {
                        let tmp = {
                            //dynamicallyAdded: true
                        };
                        tmp[that.props.field.searchTextField] = that._multiSelectValue[i][that.props.field.dataTextField];
                        tmp[that.props.field.searchValueField] = that._multiSelectValue[i][that.props.field.dataValueField];
                        rawDS.push(tmp);
                    }

                    callback(rawDS);
                }
            });
        }

        sheet.bind(SheetEventType.Close, (data) => {
            var inputRef = this._getInputRef();
            if (inputRef)
                Button.updateFocus(inputRef);
            this.props.onClose && this.props.onClose();
        });


        sheet.bindAfterInteraction(SheetAfterInteractionEventType.AfterHide, () => {
            var nl = document.getElementsByName(this.props.field.model);
            if (nl.length == 1) {
                var validator = ($(nl[0]) as any).form().data("kendoValidator");
                validator?.validateInput(nl[0]);
            }
        });

        if (this.props.onOpened)
            this.props.onOpened();
    }

    private _processTemplate = (datasourceUrl: string): string => {
        try {
            if (this._dataSourceUrlHasTemplate(datasourceUrl)) {
                datasourceUrl = Helper.processTemplate(datasourceUrl, ((match) => {
                    const result = this.props.handleEval(match);
                    if (Helper.hasValue(result)) {
                        if (!Helper.hasValue(this.props.field.encodeUrl) || this.props.field.encodeUrl) {
                            return encodeURIComponent(result);
                        } else {
                            return result; //encodeURIComponent(result);
                        }
                    } else {
                        return "";
                    }
                }));
            }
        } catch (ex) {
            console.error("Could not process dataSourceUrl teplate. " + ex)
        }
        return datasourceUrl;
    }

    private _dataSourceUrlHasTemplate = (datasourceUrl: string): boolean => {
        let reg = new RegExp("\{{2,3}[^{}]+\}{2,3}");
        return (Helper.hasValue(reg.exec(datasourceUrl)));
    }

    private _getInputRef = (): any => {
        return this._autoCompleteRef ?? this._textBoxRef ?? this._multiSelectRef;
    }

    private checkBool = (value: boolean) => {
        return Helper.hasValue(value) ? value : false;
    }

    private _handleKeyDownCapture = (e) => {
        if (e && e.key == "Escape" && !this.isEnabled()) {
            e.stopPropagation();
        }
    }

    render() {
        if (this._textBoxProps) {
            this._textBoxProps.value = Helper.hasValue(this.props.value) ? this.props.value : "";
            this._textBoxProps.disabled = !this.isEnabled();
            this._textBoxProps.required = this.props.required;
        }
        const deleteButtonTitle = Helper.hasValue(this.props.field.deleteButtonTitle) ? this.props.field.deleteButtonTitle : Config.translations.deleteLabel;

        const d = this.isCheckReadOnly(this.props.field.deleteButtonReadOnly);
        const c = this.isCheckReadOnly(this.props.field.customButtonReadOnly);
        const s = this.isCheckReadOnly(this.props.field.searchButtonReadOnly);


        const preventFocus = !Helper.hasValue(this.props.preventButtonFocus) ? false : this.props.preventButtonFocus;

        const inputRef = this._getInputRef();
        const optionalName = this.props.field.model && this.props.field.model !== "n/a" ? { name: this.props.field.model } : {};

        const newButtonEnabled = typeof this.props.field.newButtonEnabled === "string" ? this.props.handleEval(this.props.field.newButtonEnabled) : this.props.field.newButtonEnabled;
        const deleteButtonEnabled = typeof this.props.field.deleteButtonEnabled === "string" ? this.props.handleEval(this.props.field.deleteButtonEnabled) : this.props.field.deleteButtonEnabled;
        const searchButtonEnabled = typeof this.props.field.searchButtonEnabled === "string" ? this.props.handleEval(this.props.field.searchButtonEnabled) : this.props.field.searchButtonEnabled;
        const customButtonEnabled = typeof this.props.field.customButtonEnabled === "string" ? this.props.handleEval(this.props.field.customButtonEnabled) : this.props.field.customButtonEnabled;

        return (
            <div className="is-search-field" data-context={this.props.context?.contextType} data-readonly={!this.isEnabled()} data-contains-buttons={this.checkBool(!this.props.disabled && (newButtonEnabled || deleteButtonEnabled || searchButtonEnabled || customButtonEnabled))} >
                {
                    this.props.multiSelectMode ?
                        <MultiSelect ref={(r) => this._multiSelect = r} field={this.props.field as any} value={this._multiSelectValue} context={this.props.context} style={{ flex: "1" }}
                            onChange={this._handleMultiSelectChange} dataSource={this._multiSelectDataSource} disabled={/*!this._enabled*/true} commandManager={this.props.commandManager} />
                        :
                        (
                            this.props.field.autocompleteEnabled ?
                                <input ref={(r) => this._autoCompleteRef = r} style={{ flex: "1" }} required={this.props.required} data-label={this.props.field.name} {...optionalName}
                                    onKeyDownCapture={this._handleKeyDownCapture} />
                                :
                                <div style={{ flex: 1 }}><TextBox ref={(r) => { this._textBoxRef = r }}{...this._textBoxProps} /></div>
                        )
                }



                {newButtonEnabled ? <Button refInput={inputRef} buttonStyle={this._getButtonStyle(!newButtonEnabled)} iconName="plus" title={this.props.field.newObjectWindowTitle} handleClick={this._openAddNew} preventButtonFocus={preventFocus} /> : null}
                {deleteButtonEnabled ? <Button refInput={inputRef} buttonStyle={this._getButtonStyle(!deleteButtonEnabled)} readOnly={d} iconName="trash-alt" title={deleteButtonTitle} handleClick={this._deleteValue} preventButtonFocus={preventFocus} /> : null}
                {searchButtonEnabled ? <Button refInput={inputRef} buttonStyle={this._getButtonStyle(!searchButtonEnabled)} readOnly={s} iconName={Helper.hasValue(this.props.field.searchIconName) ? this.props.field.searchIconName : "search"} title={this.props.field.searchWindowTitle} handleClick={this.openSearch} preventButtonFocus={preventFocus} /> : null}
                {customButtonEnabled ? <Button refInput={inputRef} buttonStyle={this._getButtonStyle(!customButtonEnabled)} readOnly={c} iconName={Helper.isNullOrEmpty(this.props.field.customButtonIcon) ? "reply" : this.props.field.customButtonIcon} title={this.props.field.customButtonTitle} handleClick={this._execCustomFunction} preventButtonFocus={preventFocus} /> : null}
            </div>
        );
    }
};
export interface IsSearchFieldProps extends BaseComponentProps {
    field: IsSearchFieldField;
    multiSelectMode?: boolean;
    handleEval(action: string, prepare?: any);
    handleIsSearchFieldFullObjectModel(field: { model: string }, object: any);
    onOpened?();
    onClose?();
    commandManager: CommandManagerAPI;
    preventButtonFocus?: boolean;
}
export interface IsSearchFieldField extends BaseField {
    autocompleteEnabled: boolean;
    autocompleteTemplate?: string;
    autocompleteUrl?: string;
    autocompleteDataTextField?: string;
    autocompleteAdditionalFilterParameterName?: string;
    autocompleteAdditionalFilterParameter?: string;
    clearButtonEnabled?: boolean;
    searchButtonEnabled: boolean | string;
    searchButtonReadOnly?: boolean | string;
    searchWindowTitle: string;
    searchWindowUrl: string;
    encodeUrl?: boolean;
    searchWindowUrlParameterName?: string;
    searchWindowUrlParameterModel?: string;
    searchWindowUrlAdditionalParameterName?: string;
    searchWindowUrlAdditionalParameterModel?: string;
    fullObjectKey?: string;
    listWidth?: number;
    readOnlyTextField?: boolean | string;

    customButtonEnabled?: boolean | string;
    customButtonReadOnly?: boolean | string;
    customButtonTitle?: string;
    customButtonIcon?: string;
    customButtonFunction?: string;
    deleteButtonEnabled?: boolean | string;
    deleteButtonReadOnly?: boolean | string;
    deleteButtonTitle?: string;

    newButtonEnabled?: boolean | string;
    addNewUrl?: string;
    newObjectKey?: string;
    newObjectWindowTitle?: string;
    addNewUrlParameters?: StringKeyDictionary<string>;
    canOpenAdd?: string | boolean;

    dataTextField?: string;
    dataValueField?: string;
    searchTextField?: string;
    searchValueField?: string;

    focus?: boolean;
    searchIconName?: string;
    autoCompleteMultiMode?: boolean;
}